<template>
  <div class="container-xxl h-100">
    <div class="row justify-content-center">
      <div class="col-12 col-sm-8 pt-3 pb-3">
        <h1 class="py-3">Favourite Rides</h1>
        <p>
          If you decide a ride no longer belongs on your favourites list, you can wave your wand right here in this list and make it disappear
          — or, if you prefer, venture to its page in the park and tap that little star again. Either way, poof! it’s gone, just like magic!
        </p>
        <div v-if="favouriteRides.length">
          <div class="d-flex justify-content-end">
            <div class="my-4 me-3">
              <span class="pe-3 pt-3 sort-favourites">Sort by wait time:</span>
              <button
                  @click="toggleSortType()"
                  class="sort-order toggle-favourites btn sort-button text-white border-0 rounded-circle p-0 d-inline-flex align-items-center justify-content-center flex-shrink-0"
                  :aria-label="'Sort by wait time: ' + (sortType === 'Short' ? 'Ascending' : 'Descending')">
                <!-- Show DOWN arrow when sorting Short -> Long -->
                <svg v-if="sortType === 'Short'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" class="m-2">
                  <path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1"/>
                </svg>

                <!-- Show UP arrow when sorting Long -> Short -->
                <svg v-if="sortType === 'Long'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" class="m-2">
                  <path fill-rule="evenodd" d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5"/>
                </svg>
              </button>
            </div>
          </div>
          <div v-for="ride in sortedFavourites" :key="ride.id">
            <div v-if="ride.is_open === true" class="card ride-card my-4 p-3">
              <div class="d-sm-flex justify-content-sm-between">
                <h2>{{ ride.name }}</h2>
                <p>Ride status: <span class="is-open">OPEN</span></p>
              </div>
              <div v-if="ride.wait_time >= 60" :class="'long-wait'">
                <p class="text-sm-start">Current waiting time: {{ ride.wait_time }} mins</p>
              </div>
              <div v-else-if="ride.wait_time >= 30 && ride.wait_time <= 59 " :class="'med-wait'">
                <p class="text-sm-start">Current waiting time: {{ ride.wait_time }} mins</p>
              </div>
              <div v-else class="good-wait">
                <p class="text-sm-start">Current waiting time: {{ ride.wait_time }} mins</p>
              </div>
              <p class="small"><i>Wait time last updated: {{ formatUpdatedDate(ride.last_updated) }}</i></p>
              <div class="text-end">
                <font-awesome-icon icon="fa-star" class="favourite-icon selected" @click="toggleFavouriteFor(ride)" />
              </div>
            </div>
            <div v-else class="is-closed card ride-card p-3">
              <div class="d-sm-flex justify-content-sm-between">
                <h2>{{ ride.name }}</h2>
                <p>Ride status: <span class="ride-closed">CLOSED</span></p>
              </div>
              <p>RIDE IS CURRENTLY CLOSED - CHECK AGAIN SOON</p>
              <p class="small"><i>Wait time last updated: {{ formatUpdatedDate(ride.last_updated) }}</i></p>
              <div class="text-end">
                <font-awesome-icon icon="fa-star" class="favourite-icon selected" @click="toggleFavouriteFor(ride)" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
export default {
  name: 'Favourites',
  components: {
    FontAwesomeIcon
  },

  data() {
    return {
      allRides: [],
      favouriteIds: [],
      favouriteRides: [],
      lands: [],
      sortType: 'Short',
      wikis: [],
      selectedRides: [],
      rideOpen: true,
      rideClosed: true
    }
  },

  async created() {
    this.favouriteIds = JSON.parse(localStorage.getItem('favourites')) || [];
    const disneyParkIds = [4,5,6,7,8,16,17,28,64,65,66,67,334];

    const requests = disneyParkIds.map(id =>
        axios.get(`/api/parks/${id}/queue_times.json`)
    );

    Promise.all(requests).then(responses => {

      this.allRides = responses
          .map(response => response.data.lands.map(land => land.rides).flat())
          .flat();
      this.favouriteRides = this.allRides.filter(ride => this.favouriteIds.includes(ride.id)
    );
    }).catch(error => {
      console.error('Error fetching park data:', error);
    });
  },

  methods: {
    formatUpdatedDate(dateStr) {
      // Variable created to get a new date, taking in a string
      const date = new Date(dateStr);
      // returning the date in localeString format - then you can use formatUpdatedDate in the vue component
      // like this {{ formatUpdatedDate(rides.last_updated) }} to change the format of the last_updated data being pulled through
      return date.toLocaleString();
    },

    toggleSortType() {
      this.sortType = this.sortType === 'Short' ? 'Long' : 'Short';
    },

    toggleFavouriteFor(ride) {
      // Get existing favourites from localStorage
      let favourites = JSON.parse(localStorage.getItem('favourites')) || [];

      // If any of the favourites include a ride id - when clicking on the toggle the code below will filter it out from the favourites list
      if (favourites.includes(ride.id)) {
        favourites = favourites.filter(id => id !== ride.id);
      }
      localStorage.setItem('favourites', JSON.stringify(favourites));
      this.favouriteRides = favourites;
      window.location.reload();
      // localStorage.getItem('favourites', JSON.stringify(favourites));
    },
  },

  computed: {
    sortedFavourites() {
      // This variable uses the spread operator to copy all the elements from favouriteRides into a new array called rides
      // then we can use the sort method on the new array (rides) to sort by longest or shortest wait time without affecting the original array.
      let rides = [...this.favouriteRides];
      // console.log(rides);

      if (this.sortType === 'Short') {
          return rides.sort((a, b ) => a.wait_time - b.wait_time) && rides.sort((c, d) => d.is_open - c.is_open);
        } else if (this.sortType === 'Long') {
          return rides.sort((a,b) => b.wait_time - a.wait_time) && rides.sort((c, d) => c.is_open - d.is_open);
        }
      return rides;
    }
  }
}
</script>